var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Decorative/Truck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.125 2C0.503906 2 0 2.50391 0 3.125V10.625C0 11.2461 0.503906 11.75 1.125 11.75H1.5C1.5 12.9922 2.50781 14 3.75 14C4.99219 14 6 12.9922 6 11.75H9C9 12.9922 10.0078 14 11.25 14C12.4922 14 13.5 12.9922 13.5 11.75H14.25C14.6648 11.75 15 11.4148 15 11C15 10.5852 14.6648 10.25 14.25 10.25V8.75V8V7.56172C14.25 7.16328 14.093 6.78125 13.8117 6.5L12 4.68828C11.7188 4.40703 11.3367 4.25 10.9383 4.25H9.75V3.125C9.75 2.50391 9.24609 2 8.625 2H1.125ZM9.75 5.75H10.9383L12.75 7.56172V8H9.75V5.75ZM4.875 11.75C4.875 12.3711 4.37109 12.875 3.75 12.875C3.12891 12.875 2.625 12.3711 2.625 11.75C2.625 11.1289 3.12891 10.625 3.75 10.625C4.37109 10.625 4.875 11.1289 4.875 11.75ZM11.25 12.875C10.6289 12.875 10.125 12.3711 10.125 11.75C10.125 11.1289 10.6289 10.625 11.25 10.625C11.8711 10.625 12.375 11.1289 12.375 11.75C12.375 12.3711 11.8711 12.875 11.25 12.875Z",
    fill: "black"
  }))));
};

export default __webpack_public_path__ + "static/media/icon-catalog-shipping-truck.401d1838.svg";
export { SvgComponent as ReactComponent };